import React from 'react';
import { Download } from 'lucide-react';
import { Button } from './ui/button';
import { useSticker } from '../context/StickerContext';
import { getCanvasDataURL } from '../utils/canvas/exportHandlers';
import { useWindow } from '../hooks/useWindow';
import { useAnalytics } from '../context/AnalyticsContext';
import { trackEvents, trackStickerDesign } from '../utils/analytics';
import { usePrice } from '../hooks/usePrice';

export default function DownloadButton() {
  const { canvas, size, designName, canvasShape, finish } = useSticker();
  const { isMobile } = useWindow();
  const { analytics } = useAnalytics();
  const { pricePerSticker, totalPrice } = usePrice();

  const handleDownload = async () => {
    if (!canvas) return;

    try {
      const dataUrl = await getCanvasDataURL(canvas);
      const link = document.createElement('a');
      link.href = dataUrl;
      link.download = `${designName || 'sticker-design'}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      // Track download event
      trackStickerDesign(analytics, trackEvents.DESIGN_DOWNLOADED, {
        design_name: designName,
        width: size.width,
        height: size.height,
        shape: canvasShape,
        finish: finish,
        price_per_sticker: pricePerSticker,
        total_price: totalPrice,
        file_type: 'png',
        canvas_elements_count: canvas.getObjects().length
      });
    } catch (error) {
      console.error('Error downloading design:', error);
    }
  };

  return (
    <Button
      variant="outline"
      size={isMobile ? "icon" : "default"}
      onClick={handleDownload}
      className={`
        transition-all duration-200
        hover:bg-accent hover:text-accent-foreground hover:shadow-md
        border-border/50
        ${isMobile ? 'aspect-square p-2' : 'px-4 py-2'}
      `}
    >
      <Download className={`${isMobile ? 'h-5 w-5' : 'h-4 w-4 mr-2'}`} />
      {!isMobile && 'Download'}
    </Button>
  );
}